const sliderCave = {
    init() {

        const swiperCave = document.querySelector('.swiper_cave');

        if(swiperCave) {
            const swiper_cave = new Swiper('.swiper_cave', {
                loop: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                watchSlidesVisibility: false,
                spaceBetween: 0,
                loopFillGroupWithBlank: false,
                loopedSlides: 4,
                speed: 2000,
                effect: "fade",
                autoplay: { 
                    delay: 1000,
                },
            });
        }
    }
}

export default sliderCave;